export const SERVICE_SEARCH_PLACEHOLDER = "Search for services";
export const OPEN_SERVICE_SEARCH_EVENT = "open-service-search";

export const openServiceSearch = () => {
  window.dispatchEvent(new CustomEvent(OPEN_SERVICE_SEARCH_EVENT));
};
